var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"hero"},[_c('iframe',{style:({
      height: 'fit-content',
      maxHeight: '100vh',
      height: 'calc(100vh - 219px)',
    }),attrs:{"src":("https://theoremreach.com/respondent_entry/direct?api_key=0ef84efa4096353e8d1bf69f9521&user_id=" + _vm.userId + "&transaction_id=" + (Date.now()))}})])}
var staticRenderFns = []

export { render, staticRenderFns }